import { getApiUrl, getEnvVar } from "@dashboard/common/utils";
import { StorageItem } from "@dashboard/constants/storage-items";
import { fetchAllPlans } from "./premium.services";

export type CouponValidationResult =
  | { status: "free_onboarding"; coupon: string }
  | { status: "applied"; coupon: string; planName?: string }
  | { status: "invalid"; coupon: string }
  | { status: "error"; coupon: string };

export const addReferral = async (referral: string, token: string): Promise<any> => {
	const response = await fetch(`${getApiUrl()}/api/ms/growth/referrals`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Accept': 'application/json',
			'Authorization': `Bearer ${token}`,
		} as { [key: string]: string },
		body: JSON.stringify({
      'referral_id': referral,
      'origin': 'ONBOARDING',
    }),
	});
	if (response.status === 200) {
		const responseJson = await response.json();
		return responseJson;
	} else return null;
};

export const validateCouponCode = async (
  coupon: string,
  country: string,
  token: string
): Promise<CouponValidationResult> => {
  const normalized = coupon.trim();
  if (!normalized) {
    return { status: "invalid", coupon: normalized };
  }

  try {
    const baseUrl = getApiUrl();

    const onboardingCouponResponse = await fetch(
      `${baseUrl}/api/ms/prime/order-membership-payment/onboarding`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        } as { [key: string]: string },
        body: JSON.stringify({
          coupon_code: normalized,
        }),
      }
    ).then((r) => (r.status === 200 ? r.json() : null));

    if (onboardingCouponResponse?.total_value === 0) {
      if (onboardingCouponResponse?.url_stripe) {
        sessionStorage.setItem(
          StorageItem.OnboardingFreeUrl,
          onboardingCouponResponse.url_stripe
        );
      }
      return { status: "free_onboarding", coupon: normalized };
    }

    const response = await fetchAllPlans(country, normalized, token);
    const matchedPlan = response.find((plan: any) => {
      if (!plan.cart.applied_offers?.length) return false;
      return plan.cart.applied_offers.some(
        (offer: any) => offer.offer_code === normalized
      );
    });

    if (matchedPlan) {
      return {
        status: "applied",
        coupon: normalized,
        planName:
          matchedPlan?.benefit_plan?.name ||
          matchedPlan?.additional_data?.plan_type ||
          undefined,
      };
    }

    return { status: "invalid", coupon: normalized };
  } catch {
    return { status: "error", coupon: normalized };
  }
};
